import { makeStyles } from '@material-ui/core/styles';

export const classes = makeStyles((theme) => ({
    list: {
        width: 250
      },
      fullList: {
        width: "auto"
      }
}));